import type { PlanRow, QuantityBasis } from "./contracts.js";

export function planAmount(row: Pick<PlanRow, "productionAmountRaw">): number | null {
  const raw = row.productionAmountRaw?.trim();
  if (!raw) return null;
  const turkishThousands = /^\d{1,3}(?:\.\d{3})+(?:,\d+)?$/u.test(raw);
  if (!turkishThousands && !/^\d+(?:[.,]\d+)?$/u.test(raw)) return null;
  const amount = Number(turkishThousands ? raw.replaceAll(".", "").replace(",", ".") : raw.replace(",", "."));
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}

export function calculatedLabelQuantity(row: Pick<PlanRow, "productionAmountRaw">, basis: QuantityBasis | null): number | null {
  const amount = planAmount(row);
  if (amount === null || !basis?.planUnit || !basis.labelTarget || !basis.labelsPerTarget) return null;
  const kgPerCase = basis.planUnit === "kg" ? basis.kgPerCase : 1;
  const targetsPerCase = basis.labelTarget === "koli" ? 1 : basis.targetsPerCase;
  if (!kgPerCase || !targetsPerCase) return null;
  const targets = amount / kgPerCase * targetsPerCase;
  const roundedTargets = Math.ceil(targets - Number.EPSILON * Math.abs(targets) * 4);
  const labels = roundedTargets * basis.labelsPerTarget;
  return Number.isSafeInteger(labels) && labels > 0 && labels <= 100000000 ? labels : null;
}
